import { Link2 } from "lucide-react";
import { useSearchParams } from "react-router-dom";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import DecoratorExistingUserTab from "@/features/users/ui/decorator-existing-user-tab";
import DecoratorNewUserTab from "@/features/users/ui/decorator-new-user-tab";

type TabKey = "existing" | "new";

const isTabKey = (v: string | null): v is TabKey => v === "existing" || v === "new";

export default function DecoratorLinks() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const activeTab: TabKey = isTabKey(tabParam) ? tabParam : "existing";

  const handleTabChange = (next: string) => {
    const newParams = new URLSearchParams(searchParams);
    if (next === "existing") {
      newParams.delete("tab");
    } else {
      newParams.set("tab", next);
    }
    setSearchParams(newParams);
  };

  return (
    <div className="p-6 max-w-2xl mx-auto space-y-6">
      <h1 className="text-2xl font-semibold flex items-center gap-2">
        <Link2 className="h-6 w-6" />
        Decorator Links
      </h1>

      <Tabs value={activeTab} onValueChange={handleTabChange}>
        <TabsList className="mb-4">
          <TabsTrigger value="existing">Existing user (Bundle usage)</TabsTrigger>
          <TabsTrigger value="new">New user (Onboarding)</TabsTrigger>
        </TabsList>

        <TabsContent value="existing">
          <DecoratorExistingUserTab />
        </TabsContent>

        <TabsContent value="new">
          <DecoratorNewUserTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
